import React from 'react';
import { useParams } from 'react-router-dom';
import DbtModelExplorer from '../../components/dbt/DbtModelExplorer';
import { FeatureGate } from '../../components/billing';

/**
 * DbtModelsPage
 * Page displaying all models for a project
 */
const DbtModelsPage = () => {
  const { projectId } = useParams();

  return (
    <FeatureGate
      feature="dbt_enabled"
      upgradeMessage="Explore and manage your dbt models."
    >
      <div className="container mx-auto px-4 py-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold">dbt Models</h1>
          <p className="text-base-content/70 mt-2">
            Explore and manage your dbt models
          </p>
        </div>

        {projectId ? (
          <DbtModelExplorer projectId={projectId} />
        ) : (
          <div className="alert alert-warning">
            <span>Project ID is required.</span>
          </div>
        )}
      </div>
    </FeatureGate>
  );
};

export default DbtModelsPage;
